import o from "./check-mark.vue2.js";
import "./check-mark.vue3.js";
import r from "../../_virtual/_plugin-vue_export-helper.js";
const f = /* @__PURE__ */ r(o, [["__scopeId", "data-v-91b6cf9d"]]);
export {
  f as default
};
//# sourceMappingURL=check-mark.vue.js.map
